const GLOBAL_LIST_LEVEL_MAP = {
  COURSE_FIELDS: 2,
  LOCATIONS: 2,
};

export const GLOBAL_LIST_CONSTANTS = {
  LOCATIONS: "Locations",
  TAGS: "Tags",
  MEDICAL_CERTIFICATE: "Medical Certificate",
  BANK_NAME: "Bank Name",
};

export const GLOBAL_LIST_OPTIONS = Object.keys(GLOBAL_LIST_CONSTANTS).map(
  (key) => ({
    name: GLOBAL_LIST_CONSTANTS[key],
    value: GLOBAL_LIST_CONSTANTS[key],
    maxLevel: GLOBAL_LIST_LEVEL_MAP[key] ?? 1,
  })
);
